import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import { buildProductData } from 'yoda-core-components/lib/helpers/Analytics/CJAProductBuilder';
import buildCJAEvent from 'yoda-core-components/lib/helpers/Analytics/CJAEventBuilder';
import { mapProductFromState, filterToSelectedLot, getCurrentPageUrl } from './CjaHelper';

export const buildPageViewPayload = (state) => {
    const productDetails = state.productDetails || {};
    const breadcrumbs = productDetails?.breadCrumbInfo?.breadcrumbs || [];
    const shopTheLook = state.shopTheLook || {};

    return buildCJAPageViewPayload(
        {
            name: `d:pdp:${productDetails.name || ''}`.toLowerCase(),
            type: 'pdp',
            breadcrumbs: breadcrumbs
                .map((b) => b.breadCrumbLabel || '')
                .join('>')
                .toLowerCase(),
            siteSection: breadcrumbs[1]?.breadCrumbLabel || '',
            category: {
                primary: breadcrumbs[1]?.breadCrumbLabel || '',
                sub1: breadcrumbs[2]?.breadCrumbLabel || '',
                sub2: breadcrumbs[3]?.breadCrumbLabel || '',
            },
            flags: {
                isErrorPage: !!state.ErrorPage,
                isChatAvailable: true,
                isShopTheLookModule: !!(
                    shopTheLook.productPrices && shopTheLook.productPrices.length
                ),
            },
            tech: {
                releaseVersion: (state.context || {}).__RELEASEVERSION__ || '',
                version: `apollo 1 pdp - ${productDetails.templateType || 'standard'}`,
            },
        },
        {},
        {
            interactionName: 'product_view',
            products: buildProductData([mapProductFromState(state)]),
        }
    );
};

export const buildAddToCartPayload = (state, payload, cartAddType) => {
    const sourceMiniPDP = payload.sourceMiniPDP || false;
    const mapped = mapProductFromState(state, sourceMiniPDP);
    const { selectedQuantity } = mapped;
    const selectedLot = filterToSelectedLot(mapped);

    return {
        event: 'add_to_cart',
        event_name: 'add_to_cart',
        cartAddType,
        cartAddLocation: 'pdp',
        products: buildProductData([
            {
                ...mapped,
                ...selectedLot,
                inventoryStatus:
                    mapped.inventoryStatus === 'in stock' ? 'in_stock' : 'out_of_stock',
                quantity:
                    selectedQuantity && selectedQuantity !== 0 ? parseInt(selectedQuantity, 10) : 1,
                deliveryMethod: (payload.deliveryMethod || '').toLowerCase(),
                deliveryDays: payload.deliveryDays || '',
                deliveryDayType: payload.deliveryDayType || '',
                productClickPosition: payload.clickPosition || '',
                cartAddLocation: 'pdp',
                flags: {
                    ...mapped.flags,
                    isMaxQuantityReached: !!payload.maxQuantityMsgDisplay,
                },
            },
        ]),
    };
};

export const buildProductOOSPayload = (state) =>
    buildCJAEvent({
        event: 'linkClick',
        event_name: 'linkClick',
        linkComponent: 'pdp',
        linkText: 'out of stock',
        linkType: 'other',
        linkUrl: getCurrentPageUrl(),
        linkModuleName: 'productOOS',
        linkRegion: 'product details',
        products: buildProductData([
            {
                ...mapProductFromState(state),
                inventoryStatus: 'out_of_stock',
            },
        ]),
    });

export const buildErrorPayload = (errors) => {
    const errorList = Array.isArray(errors) ? errors : [errors || {}];
    return {
        event: 'error',
        event_name: 'error',
        error: errorList.map((e) => ({
            type: `pdp:${e.errorType || e.type || 'error'}`,
            id: e.errorID || e.errorCode || '',
            message: e.errorDescription || e.errorMessage || '',
        })),
    };
};

export const buildLinkClickPayload = (linkComponent, linkText, linkModuleName, extra) =>
    buildCJAEvent({
        event: 'linkClick',
        event_name: 'linkClick',
        linkComponent,
        linkText: linkText || '',
        linkType: 'other',
        linkUrl: getCurrentPageUrl(),
        linkModuleName: linkModuleName || '',
        ...extra,
    });

export const buildSelectOptionsPDPPayload = (state, payload) => {
    const mapped = mapProductFromState(state);
    const selectedLot = filterToSelectedLot(mapped);

    return {
        event: 'selectoptionspdp',
        event_name: 'selectoptionspdp',
        interactionName: 'product_view',
        products: buildProductData([
            {
                ...mapped,
                ...selectedLot,
                lotId: selectedLot.lotId.length
                    ? selectedLot.lotId
                    : payload.productLotId || mapped.lotId,
                inventoryStatus:
                    mapped.inventoryStatus === 'in stock' ? 'in_stock' : 'out_of_stock',
            },
        ]),
    };
};

export const buildSaveProductPayload = (actionPayload) => {
    const productInfo = (actionPayload?.product || [])[0]?.productInfo || {};
    return {
        event: 'save_product',
        event_name: 'save_product',
        products: buildProductData([
            {
                id: productInfo.productPPID || '',
                name: (productInfo.productName || '').toLowerCase(),
                imgSource: productInfo.productImageSrc || '',
                link: productInfo.productLink || '',
                sellerName: productInfo.mpSellername || '',
                sellerType: productInfo.productSellertype || '',
            },
        ]),
    };
};
